import React from 'react';
import { TextInput } from "../../components";
import SignatureInput from "../../components/signature-input/SignatureInput";
import FormField from "../../components/form/FormField";
import DateUtil from "../../utils/DateUtil";
import moment from "moment";
import SignatureDisplay from '../../components/signature-input/SignatureDisplay';
import { isMinor } from '../patient/Patient';
import PsychologyFormTextEnum from './enum/PsychologyFormTextEnum';

const PsychologyWizardPage = ({
    patient,
    form,
    readOnly,
    patientName,
    patientDOB,
    mrnNo,
    onSavePatientSignature,
    onSaveWitnessSignature,
    pushFormFieldRef,
    guardianName,
    guardianRelationship,
    patientSignature,
    patientDate,
    witnessName,
    witnessSignature,
    providerName,
    providerSignature,
    selectedLanguage,
    enumLabel,
    ...commonProps
}) => {
    const { onChange } = commonProps;
    const textEnum = PsychologyFormTextEnum;
    const isPatientMinor = isMinor(patientDOB, 'UAE');

    const getLocalizedText = (key) => {
        return textEnum[key] ? textEnum[key][selectedLanguage] : '';
    };

    return (
        <div style={{ maxWidth: '950px' }}>
            <div style={{
                marginTop: '15px', marginBottom: '15px', width: '100%', display: 'flex',
                flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'
            }}>
                <h2>{getLocalizedText('Form_Title')}</h2>
            </div>

            <hr style={{
                borderTop: "2px solid #000000",
                marginTop: "-10px",
                boxShadow: "0px 2px 2px #797979"
            }} />

            <div style={{ border: "1px solid #000000" }}>
                <div style={{ margin: "15px 15px" }}>
                    <h5>{getLocalizedText('Patient_Information')}</h5>
                    <div className={"row"} style={{ marginTop: "10px", marginLeft: "0px" }}>
                        <div className="col-md-5">
                            <b>{getLocalizedText('Name')}</b> {patientName}
                        </div>
                        <div className="col-md-4">
                            <b>{getLocalizedText('MRN')}</b> {mrnNo}
                        </div>
                        <div className="col-md-3">
                            <b>{getLocalizedText('DOB')}</b> {DateUtil.formatDate(patientDOB)}
                        </div>
                    </div>
                </div>
            </div>

            <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                <div style={{ margin: "15px 15px" }}>
                    <p>{getLocalizedText('Treatment_Consideration')}</p>
                    <p>{getLocalizedText('Understanding')}<br />
                        <ul>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point1')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point2')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point3')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point4')}
                                    <ul>
                                        <li>
                                            <p>
                                                {getLocalizedText('Understanding_Point4_1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {getLocalizedText('Understanding_Point4_2')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {getLocalizedText('Understanding_Point4_3')}
                                            </p>
                                        </li>
                                        <li>
                                            <p>
                                                {getLocalizedText('Understanding_Point4_4')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point5')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point6')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point7')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point8')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point9')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point10')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point11')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point12')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Understanding_Point13')}
                                </p>
                            </li>
                        </ul>
                    </p>
                </div>
            </div>

            <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                <div style={{ margin: "10px 15px" }}>
                    <p><b>{getLocalizedText('Psychology_Data_Collection_Header')}</b><br />
                    </p>
                    <p>{getLocalizedText('Psychology_Data_Collection_Information')}<br />
                    </p>
                    <p>{getLocalizedText('Psychology_Data_Collection_Purpose')}<br />
                    </p>
                    <p>{getLocalizedText('Psychology_Data_Protection_Header')}<br />
                        <ul>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Data_Protection_Point1')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Data_Protection_Point2')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Data_Protection_Point3')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Data_Protection_Point4')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Data_Protection_Point5')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Data_Protection_Point6')}
                                </p>
                            </li>
                        </ul>
                    </p>
                    <p>{getLocalizedText('Psychology_Data_Sharing')}<br />
                    </p>
                    <p>{getLocalizedText('Psychology_Marketing')}<br />
                    </p>
                </div>
            </div>

            <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                <div style={{ margin: "10px 15px" }}>
                    <p>{getLocalizedText('Psychology_Patient_Rights_Header')}<br />
                        <ul>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Patient_Rights_Point1')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Patient_Rights_Point2')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Patient_Rights_Point3')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Patient_Rights_Point4')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Patient_Rights_Point5')}
                                </p>
                            </li>
                            <li>
                                <p>
                                    {getLocalizedText('Psychology_Patient_Rights_Point6')}
                                </p>
                            </li>
                        </ul>
                    </p>
                    <p><b>{getLocalizedText('Psychology_Questions_Concerns')}</b><br />
                        {getLocalizedText('Psychology_Questions_Concerns_Description')}
                    </p>
                    <p><b>{getLocalizedText('Psychology_Complaints_Header')}</b><br />
                        {getLocalizedText('Psychology_Complaints_Description')}<br />
                        {getLocalizedText('Psychology_Complaints_DHA')}<br />
                    </p>
                </div>
            </div>

            <div style={{ border: "1px solid #000000", margin: "10px 0px" }}>
                <div style={{ margin: "10px 15px" }}>
                    <p><b>{getLocalizedText('Psychology_Patient_Responsibility')}</b>
                    </p>
                    <p><b>{getLocalizedText('Psychology_Final_Acknowledgment')}</b>
                    </p>
                    <p><b>{getLocalizedText('Psychology_Data_Understanding')}</b>
                    </p>
                </div>
            </div>

            <div className={"container"}>
                <div className={"row"} style={{ marginTop: "10px" }}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Date')}
                    </div>

                    <div className="col-md-3">
                        {readOnly && form.patientDate ?
                            moment(new Date(form.patientDate)).format('MMMM DD, YYYY')
                            :
                            moment(new Date(patientDate)).format('MMMM DD, YYYY')
                        }
                    </div>
                </div>

                <div className="row" style={{ marginTop: "15px" }}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Patient_Name')}
                    </div>
                    <div className="col-md-3">
                        {patientName}
                    </div>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Provider_Name')}
                    </div>
                    <div className="col-md-3">
                        <TextInput value={providerName} required validateOn={true}
                            disabled style={{ textAlign: "center" }} />
                    </div>

                </div>

                <div className={"row"} style={{ marginTop: "10px" }}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Print_Name')}
                    </div>
                    <div className="col-md-3">
                        <FormField ref={pushFormFieldRef}
                            disabled={!isPatientMinor}
                            required requiredMessage={getLocalizedText('Field_Required')}
                            validateOn={guardianName}>
                            <TextInput value={guardianName}
                                disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                onChange={(val) => onChange("guardianName", val)} />
                        </FormField>
                    </div>
                </div>
                <div className={"row"} style={{ marginTop: "10px" }}>
                    <div className="col-md-3 dim14-form-label">
                        {getLocalizedText('Relationship_To_Patient')}
                    </div>
                    <div className="col-md-3 dim14-base-input">
                        <FormField ref={pushFormFieldRef}
                            disabled={!isPatientMinor}
                            required requiredMessage={getLocalizedText('Field_Required')}
                            validateOn={guardianRelationship}>
                            <TextInput
                                value={guardianRelationship}
                                disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                onChange={(val) => onChange("guardianRelationship", val)} />
                        </FormField>
                    </div>
                </div>

                <div className={"row"} style={{ marginTop: "10px" }}>
                    <div className="col-md-6 dim14-form-label">
                        {getLocalizedText('Patient_Signature')}
                    </div>
                    <div className="col-md-6 dim14-form-label">
                        {getLocalizedText('Provider_Signature')}
                    </div>
                </div>

                <div className={"row"} style={{ marginTop: "15px" }}>
                    <div className="col-md-6">
                        <FormField ref={pushFormFieldRef} required validateOn={patientSignature}
                            requiredMessage={getLocalizedText('Signature_Required')}>
                            <SignatureInput signature={patientSignature}
                                onSave={onSavePatientSignature} readOnly={readOnly} />
                        </FormField>
                    </div>
                    <div className="col-md-6">
                        <FormField ref={pushFormFieldRef} required validateOn={providerSignature}
                            requiredMessage={getLocalizedText('Signature_Required')}>
                            <SignatureDisplay signature={providerSignature} />
                        </FormField>
                    </div>
                </div>
            </div>

            <br />
            {/* Witness/Guardian Section - Required for minor patients */}
            <div className={"container mt-4"}>
                <div className={"row"} style={{ marginTop: "10px" }}>
                    <p className="font-weight-bold">
                        <u>{getLocalizedText('Official_Use_Only')}</u></p>
                    <p className="font-weight-bold">
                        {getLocalizedText('Witness_Statement_Header')}</p>
                    <p><i>{getLocalizedText('Witness_Statement')}</i></p>
                </div>

                <div className={"row"} style={{ marginTop: "10px" }}>
                    <div className="col-md-6 dim14-form-label">
                        {getLocalizedText('Witness_Name')}
                    </div>
                    <div className="col-md-6">
                        <TextInput value={witnessName}
                            disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                            onChange={(val) => onChange("witnessName", val)} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">{getLocalizedText('Witness_Signature')}</div>
                    <div className="col-md-6">
                        <SignatureInput
                            signature={witnessSignature}
                            onSave={onSaveWitnessSignature} readOnly={readOnly} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PsychologyWizardPage;
